import { Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ReactivateDiscardedTeamCard from './ReactivateDiscardedTeamCard';
import StandardPageHeader from 'components/StandardPageHeader';

const TeamManagement = () => {
  return (
    <Grid>
      <Helmet title="Team Lifecycle" />

      <StandardPageHeader
        title="Team Lifecycle"
        subtitle="Developer tools for team lifecycle management"
        icon="Teams"
        sx={{ mb: 6 }}
      />

      <Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <ReactivateDiscardedTeamCard />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TeamManagement;
